




















import Vue from "vue";
import Component from "vue-class-component";
import NameSearch from "./components/NameSearch.vue";
import CookieBanner from "./components/CookieBanner.vue";
import HeaderBar from "./components/HeaderBar.vue";
import Navbar from "./components/Navbar.vue";
import color from "color";
import { HSL } from "./models";
import { mdiGraph, mdiBaby, mdiBabyFace, mdiBabyFaceOutline } from "@mdi/js";

@Component({
  components: {
    CookieBanner,
    NameSearch,
    HeaderBar,
    Navbar
  },
  provide() {
    const primaryRGB = this.$vuetify.theme.themes.light.primary;
    const primaryHSL = color(primaryRGB).hsl();
    const secondaryRGB = this.$vuetify.theme.themes.light.accent;
    const secondaryHSL = color(secondaryRGB).hsl();

    const hue = primaryHSL.hue();
    const saturation = primaryHSL.saturationl();
    const light = primaryHSL.lightness();
    const primaryColour: HSL = { hue, saturation, light };

    const secondaryHue = secondaryHSL.hue();
    const secondarySaturation = secondaryHSL.saturationl();
    const secondaryLight = secondaryHSL.lightness();
    const secondaryColour: HSL = {
      hue: secondaryHue,
      saturation: secondarySaturation,
      light: secondaryLight
    };

    return {
      primaryColour,
      secondaryColour
    };
  },
  mounted() {
    window.addEventListener("resize", () => {
      const headerRect = this.$el
        .querySelector("header")!
        .getBoundingClientRect();
      const headerHeight = headerRect.height;
      this.$data.navbarTop = headerHeight;
    });
  }
})
export default class App extends Vue {
  showDrawer = false;
  navbarTop = 0;

  mdiBaby = mdiBabyFaceOutline;

  cookiesAccepted = Boolean(localStorage.getItem("baby-names-accept-cookies"));
  acceptCookiePolicy() {
    this.cookiesAccepted = true;
    localStorage.setItem("baby-names-accept-cookies", "true");
  }

  toggleShowDrawer() {
    this.showDrawer = !this.showDrawer;
  }
}
